/**
 * Verification ModeRail sub-nav — the shipped rail tabs for the verifier mode.
 *
 * Product tabs land on `/` (VerificationShell), not `/agents`. `area` is the
 * ModeRail health-dot join key (pulse area), not a leftover `/agents` route tail.
 */

import type { ModeShellView } from "@excellent/ui";
import { Shield, ShieldCheck } from "@excellent/ui/icons";

const ICON = "size-4";

/** Product and developer surfaces nested under Verification in the ModeRail. */
export const AGENTS_VIEWS: ModeShellView[] = [
  {
    href: "/",
    label: "Verification",
    icon: <Shield className={ICON} strokeWidth={1.75} />,
    area: "fleet",
  },
  {
    href: "/",
    label: "Readiness",
    icon: <ShieldCheck className={ICON} strokeWidth={1.75} />,
    area: "fleet",
  },
];

/**
 * Paths that are NOT product Agents surfaces — prove-outs / design proofs.
 * These must not mount ModeShell product chrome.
 */
export function isAgentsProductPath(pathname: string): boolean {
  if (pathname === "/agents" || pathname.startsWith("/agents/")) {
    if (
      pathname.startsWith("/agents/_") ||
      pathname === "/agents/retrieval" ||
      pathname === "/agents/pack" ||
      pathname.startsWith("/agents/_proof")
    ) {
      return false;
    }
    return true;
  }
  return false;
}
